import { FullProduct } from "ts/api/product";

export enum CartFlowType {
  local = "local",
  created = "created",
}

export type CartFlow =
  | {
      type: CartFlowType.local;
      products: FullProduct[];
      orderId: undefined;
    }
  | {
      type: CartFlowType.created;
      products: FullProduct[];
      orderId: string;
    };
